'use client';

import { useQuery, useMutation } from '@tanstack/react-query';

import { JWT_STORAGE_KEY, USER_ID_STORAGE_KEY } from 'src/utils/constants';

import { paymentClient } from 'src/lib/api';

export const useGetSavedCards = () => {
  const userID = sessionStorage.getItem(USER_ID_STORAGE_KEY);
  const query = useQuery({
    queryKey: ['payment_getCardsList'],
    queryFn: () =>
      paymentClient
        .get('api/v1/cards/card/list', {
          params: {
            userID,
          },
        })
        .then((res) => res?.data?.success || []),
    enabled: !!userID, // prevent auto-run if userId or driverID is undefined
  });

  return query;
};

/**
 * Card Payment for Extra Charges
 * @returns
 */
export const usePayExtraChargesUsingCard = () => {
  const token = sessionStorage.getItem(JWT_STORAGE_KEY);
  const mutationFn = (payload) =>
    paymentClient
      .post('api/v1/payments/payment/EC/extraChargeUsingCard', payload, {
        headers: {
          token,
        },
      })
      .then((res) => res.data);
  return useMutation({
    mutationFn,
    mutationKey: ['payment_usePayExtraChargesUsingCard'],
  });
};

/**
 * Card Payment for PAD
 * @returns
 */
export const usePayPADUsingCard = () => {
  const token = sessionStorage.getItem(JWT_STORAGE_KEY);
  const mutationFn = (payload) =>
    paymentClient
      .post('api/v1/payments/payment/PAD/usingCard', payload, {
        headers: {
          token,
        },
      })
      .then((res) => res.data);
  return useMutation({
    mutationFn,
    mutationKey: ['payment_usePayPADUsingCard'],
  });
};

/**
 * Card + Wallet Payment for PAD
 * @returns
 */
export const usePayPADUsingCardPlusWallet = () => {
  const token = sessionStorage.getItem(JWT_STORAGE_KEY);
  const mutationFn = (payload) =>
    paymentClient
      .post('api/v1/payments/payment/PAD/usingCardAndWallet', payload, {
        headers: {
          token,
        },
      })
      .then((res) => res.data);
  return useMutation({
    mutationFn,
    mutationKey: ['payment_usePayPADUsingCardPlusWallet'],
  });
};
